import { CalculateVenueEss } from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';
import {
  formatUnit,
  getEssSectionName,
  getEssTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareVenueTopicScoreDetailsDataEss(
  calculateVenue: CalculateVenueEss,
): TopicScoreDetailsData {
  const structureEssScore = calculateVenue.structure;
  return {
    scoreLetter: structureEssScore.scoreLetter,
    value: structureEssScore.score,
    refValue: NaN,
    maxValue: structureEssScore.maxScore,
    completion: NaN,
    sections: [
      {
        name: getEssTopicName(EssTopic.PARITY_EQUALITY),
        score: structureEssScore.topics.PARITY_EQUALITY.score,
        maxScore: structureEssScore.topics.PARITY_EQUALITY.maxScore,
        items: [
          {
            id: 'PARITY_EQUALITY-PERMANENT_OPERATIONAL_TEAM',
            name: getEssSectionName(EssSection.PERMANENT_OPERATIONAL_TEAM),
            value:
              structureEssScore.topics.PARITY_EQUALITY.sections
                .PERMANENT_OPERATIONAL_TEAM.score,
            unit: formatUnit(
              structureEssScore.topics.PARITY_EQUALITY.sections
                .PERMANENT_OPERATIONAL_TEAM.maxScore,
            ),
          },
          {
            id: 'PARITY_EQUALITY-TRANSPARENCY_MANAGEMENT',
            name: getEssSectionName(EssSection.TRANSPARENCY_MANAGEMENT),
            value:
              structureEssScore.topics.PARITY_EQUALITY.sections
                .TRANSPARENCY_MANAGEMENT.score,
            unit: formatUnit(
              structureEssScore.topics.PARITY_EQUALITY.sections
                .TRANSPARENCY_MANAGEMENT.maxScore,
            ),
          },
        ],
      },
      {
        name: getEssTopicName(EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE),
        score: structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
        maxScore:
          structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
        items: [
          {
            id: 'ACCESSIBILITY_SOCIAL_DIALOGUE-ACCESSIBILITY',
            name: getEssSectionName(EssSection.ACCESSIBILITY),
            value:
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .ACCESSIBILITY.score,
            unit: formatUnit(
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .ACCESSIBILITY.maxScore,
            ),
          },
          {
            id: 'ACCESSIBILITY_SOCIAL_DIALOGUE-RISK_PREVENTION',
            name: getEssSectionName(EssSection.RISK_PREVENTION),
            value:
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .RISK_PREVENTION.score,
            unit: formatUnit(
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .RISK_PREVENTION.maxScore,
            ),
          },
          {
            id: 'ACCESSIBILITY_SOCIAL_DIALOGUE-COMMUNICATION',
            name: getEssSectionName(EssSection.COMMUNICATION),
            value:
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .COMMUNICATION.score,
            unit: formatUnit(
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .COMMUNICATION.maxScore,
            ),
          },
          {
            id: 'ACCESSIBILITY_SOCIAL_DIALOGUE-TEAM_MANAGEMENT',
            name: getEssSectionName(EssSection.TEAM_MANAGEMENT),
            value:
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .TEAM_MANAGEMENT.score,
            unit: formatUnit(
              structureEssScore.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                .TEAM_MANAGEMENT.maxScore,
            ),
          },
        ],
      },
      {
        name: getEssTopicName(EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT),
        score: structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
        maxScore: structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
        items: [
          {
            id: 'LOCAL_IMPACT_RSE_ENGAGEMENT-LOCALITY_EMPLOYMENT_PARTNERS',
            name: getEssSectionName(EssSection.LOCALITY_EMPLOYMENT_PARTNERS),
            value:
              structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                .LOCALITY_EMPLOYMENT_PARTNERS.score,
            unit: formatUnit(
              structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                .LOCALITY_EMPLOYMENT_PARTNERS.maxScore,
            ),
          },
          {
            id: 'LOCAL_IMPACT_RSE_ENGAGEMENT-ECONOMIC_SOCIAL_IMPACT',
            name: getEssSectionName(EssSection.ECONOMIC_SOCIAL_IMPACT),
            value:
              structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                .ECONOMIC_SOCIAL_IMPACT.score,
            unit: formatUnit(
              structureEssScore.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                .ECONOMIC_SOCIAL_IMPACT.maxScore,
            ),
          },
        ],
      },
    ],
  };
}
